<template>
  <div id="authui">
    <slot></slot>
    <div id="firebaseui-auth-container"></div>
    {{ config }}
  </div>
</template>

<script>
import * as firebaseui from "firebaseui";
require("firebaseui/dist/firebaseui.css");

export default {
  name: "FireAuthUI",

  inject: ["firebase"],

  data() {
    return {
      config: {
        signInOptions: [],
        signInFlow: this.signInFlow,
        tosUrl: this.tosUrl,
        privacyPolicyUrl: this.privacyPolicyUrl
      },
      ui: new firebaseui.auth.AuthUI(this.firebase.auth())
    };
  },

  mounted() {
    this.ui.start("#firebaseui-auth-container", this.config);
  },

  provide() {
    return {
      authConfig: this.config
    };
  },

  props: {
    queryParameterForSignInSuccessUrl: {
      type: String,
      default: "signInSuccessUrl"
    },
    queryParameterForWidgetMode: {
      type: String,
      default: "mode"
    },
    signInFlow: {
      type: String,
      default: "redirect"
    },
    immediateFederatedRedirect: {
      type: Boolean,
      default: false
    },
    signInSuccessUrl: {
      type: String,
      default: null
    },
    tosUrl: {
      type: String,
      required: true
    },
    privacyPolicyUrl: {
      type: String,
      required: true
    }
    // signInOptions
    // callbacks
    // custom scopes, or custom OAuth parameters per provider
  }
};
</script>
